import { render, staticRenderFns } from "./GestionAcceso.vue?vue&type=template&id=766e5478&scoped=true"
import script from "./GestionAcceso.vue?vue&type=script&lang=js"
export * from "./GestionAcceso.vue?vue&type=script&lang=js"
import style0 from "./GestionAcceso.vue?vue&type=style&index=0&id=766e5478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e5478",
  null
  
)

export default component.exports